import "./styles.scss";

import { useTranslation } from "react-i18next";
import { CircularProgress, Divider } from "@mui/material";
import { IconPencil, IconDownload, IconChevronLeft, IconShare, IconPresentation } from "@tabler/icons-react";

import { Button, Text } from '@fragments'
import { useEffect } from 'react';
import { useScreen } from 'Screen/ScreenContext';
import CommunityPlansAvailableTable from "@components/CommunityPlansAvailableTable";
import ManageMaterialModal from "@modals/Material/ManageMaterial";

import PDFSidebar from "./components/PDFSidebar";
import PDFRender from "./components/PDFRender";
import Presentation from "./components/Presentation";

export default function MaterialView({
    material,
    loading,
    zoom,
    pdfDocument,
    currentPage,
    setCurrentPage,
    currentCommunity,
    presenting,
    REF_materialModal,
    handleDownload,
    handleOpenEditMaterial,
    handleShare,
    handleStartPresentation,
    handleStopPresentation,
    handlePageClick,
    handleGoBack,
}) {
    const { t } = useTranslation("content");
    const { setFullWidth } = useScreen();

    useEffect(() => {
        setFullWidth(true);
        return () => setFullWidth(false);
    }, [setFullWidth]);

    return (
        <div className="material-view-wrapper">
            <div className="material-view-page pb-0">
                {!(!loading && !material?.can_access) && (
                    <div className="material-layout">
                        <>
                            <PDFSidebar
                                pdf={pdfDocument}
                                currentPage={currentPage}
                                onPageClick={handlePageClick}
                                loading={loading || !pdfDocument}
                            />
                            <div className="material-container pb-6">
                                <PDFRender
                                    pdf={pdfDocument}
                                    zoom={zoom}
                                    onPageInView={setCurrentPage}
                                    loading={loading || !pdfDocument}
                                />
                            </div>
                        </>
                    </div>
                )}

                {!loading && !material?.can_access && (
                    material?.availability?.available !== true ? (
                        <div className="material-restricted-access">
                            <div className="mt-9 mb-3 material-restricted-access__header">
                                <Text.h3 className="material-restricted-access__title mb-1" contrast={8}>
                                    {t("material.restrictedTitle")}
                                </Text.h3>
                                <Text.span contrast={5}>
                                    {t("material.restrictedSubtitle")}
                                </Text.span>
                            </div>
                            <CommunityPlansAvailableTable
                                communityId={material?.community}
                                availability={material?.availability}
                            />
                        </div>
                    ) : (
                        <h4 className="mt-8">{t("material.noAccess")}</h4>
                    )
                )}

                {material?.can_access && (
                    <div className="material-footer">
                        <div className="material-footer__content">
                            <Text.h4 className="material-footer__title" title={material?.name || ''}>
                                {material?.name || ''}
                            </Text.h4>
                            <div className="material-actions">
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="small"
                                    color="overlay"
                                    startIcon={<IconChevronLeft />}
                                    onClick={handleGoBack}
                                >
                                    {t("common:actions.back")}
                                </Button>
                                <Divider orientation="vertical" flexItem className="mx-1" />
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="medium"
                                    color="overlay"
                                    startIcon={<IconPresentation />}
                                    disabled={!pdfDocument}
                                    onClick={handleStartPresentation}
                                >
                                    {t("material.present")}
                                </Button>
                                {currentCommunity?.isAdmin() && (
                                    <>
                                        <Button
                                            className="download-file-btn"
                                            variant="contained"
                                            size="medium"
                                            color="overlay"
                                            startIcon={<IconShare />}
                                            onClick={handleShare}
                                        >
                                            {t("common:actions.share")}
                                        </Button>
                                        <Button
                                            className="download-file-btn"
                                            variant="contained"
                                            size="medium"
                                            color="overlay"
                                            startIcon={<IconPencil />}
                                            onClick={handleOpenEditMaterial}
                                        >
                                            {t("common:actions.edit")}
                                        </Button>
                                    </>
                                )}
                                {(material?.allow_download !== false || currentCommunity?.isAdmin?.()) && (
                                    <Button
                                        className="download-file-btn"
                                        variant="contained"
                                        size="medium"
                                        startIcon={<IconDownload />}
                                        onClick={handleDownload}
                                    >
                                        {t("material.download")}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                )}


                {presenting && pdfDocument && (
                    <Presentation
                        pdf={pdfDocument}
                        initialPage={currentPage}
                        title={material?.name || ""}
                        onClose={handleStopPresentation}
                        onPageChange={setCurrentPage}
                    />
                )}

                <ManageMaterialModal modalRef={REF_materialModal} />
            </div>
        </div>
    );
}
